export const Loader = ({ visible }) => {
  return (
    <div
      id="page-loader"
      className={`site-loader ${visible ? "is-visible" : "is-hiding"}`}
      role="status"
      aria-live="polite"
    >
      <div className="pl-stage">
        <span className="pl-pac" aria-hidden="true">
          <span className="pl-lip pl-top" />
          <span className="pl-lip pl-bottom" />
        </span>
        <span className="pl-dots" aria-hidden="true">
          <i />
          <i />
          <i />
          <i />
          <i />
          <i />
          <i />
          <i />
        </span>
      </div>
      <p className="pl-line">Just one more dot…</p>
    </div>
  );
};
